<script lang="ts">
  import { defineComponent } from "vue";
  import FicheGestionAem from '@/generated/fiches/FicheGestionAem.vue';
  export default defineComponent({
    extends: FicheGestionAem,
    components: {}
})
</script>
